import { createFileRoute } from "@tanstack/react-router";
import { ConfirmRequestScreen } from "../../screens/confirm/ConfirmRequestScreen.tsx";

/** `/confirm/<id>`: the link an AI assistant gives its person when the gate wants a click (`ConfirmRequestScreen`). */
export const Route = createFileRoute("/_app/confirm/$requestId")({
  component: ConfirmRequestScreen,
});
